import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Header, Input, Segment, Table } from 'semantic-ui-react';
import { toast } from 'react-semantic-toasts';
import request from '../../../../utils/request';
import tableStyles from '../../../../styles/table.module.scss';
import DeleteAction from '../../../../components/admin/DeleteAction';
import Pagination from '../../../../components/admin/Pagination';

const { Cell, HeaderCell, Row} = Table;
let timer = 0;

class AdminProductsListView extends React.Component
{
    state = {
        isLoading: false,
        query: '',
        pagination: {},
        products: [],
        confirmDelete: false,
    };

    /**
     * Mount
     */
    componentDidMount = () => {
        this.fetch();
    }

    /**
     * Delete tag
     */
    deleteProduct = (tag) => {
        request.delete(`admin/products/${tag.id}`).then(() => {
            this.fetch();

            toast({
                type: 'success',
                icon: '',
                description: 'Product deleted succesfully',
                time: 2500,
            });
        });
    }

    /**
     * Fetch
     */
    fetch = () => {
        request(`admin/products?q=${this.state.query}`).then(({ data }) => {
            this.setState({
                isLoading: false,
                pagination: data.meta,
                products: data.data,
            });
        });
    }

    /**
     * Search
     */
    searchProducts = (query) => {
        clearTimeout(timer);

        this.setState({
            isLoading: true,
            query,
        });

        timer = setTimeout(() => { this.fetch(); }, 300);
    }

    // --- render
    render() {
        const { isLoading, pagination, query, products } = this.state;

        return (
            <Container className="admin-page">
                <Segment padded>
                    <div className="admin-page-header">
                        <Header as="h1">Products</Header>
                        <Link to="/admin/products/create">
                            <Button primary icon="plus" />
                        </Link>
                    </div>
                    <Input
                        fluid
                        loading={isLoading}
                        placeholder='Search...'
                        onChange={(e) => { this.searchProducts(e.target.value); }}
                        value={query}
                    />
                    <Table>
                        <Table.Header>
                            <Row>
                                <HeaderCell>Product</HeaderCell>
                                <HeaderCell singleLine textAlign="right">Actions</HeaderCell>
                            </Row>
                        </Table.Header>
                        <Table.Body>
                            {products.map((product) => (
                                <Row key={product.id}>
                                    <Cell>
                                        <Link to={`/admin/products/${product.id}`}>
                                            {product.name}
                                        </Link>
                                    </Cell>
                                    <Cell collapsing textAlign="right">
                                        <Link to={`/admin/products/${product.id}`}>
                                            <Button
                                                basic
                                                size="mini"
                                                icon="pencil"
                                            />
                                        </Link>
                                        <span className={tableStyles.actionsDivider}> | </span>
                                        <DeleteAction
                                            message="Are you sure you want to delete this product? All links items, including assets, will be delete as well"
                                            onDelete={() => { this.deleteProduct(product); }}
                                        />
                                    </Cell>
                                </Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Segment>
                <Pagination data={pagination} onClick={this.fetch} />
            </Container>
        );
    }
}

export default AdminProductsListView;
